<template>
	<validation-observer
		tag="div"
		class="cassie-vertical-md"
	>
		<SectionCard>
			<template #title>
				Data Types
			</template>
			<template #body>
				<Dropdown
					label="Data Type *"
					:value="cassieObjectId"
					:items="dataTypeItems"
					rules="required"
					class="cassie-input-width-md"
					tooltip-text="Select the Cassie Data object this service relates to"
					:disabled="!userFullPermissions"
					@input="$emit('update:cassieObjectId', $event)"
				/>
				<div class="d-flex flex-row cassie-horizontal-lg">
					<Dropdown
						label="Increment Field *"
						:value="objectIdColumn"
						:items="incrementFieldItems"
						rules="required"
						class="cassie-input-width-md"
						tooltip-text="Choose an appropriate data field within the Cassie object to be used for incremental transfers. Each transfer will send any new information within Cassie, based on this field"
						:disabled="!userFullPermissions"
						@input="$emit('update:objectIdColumn', $event)"
					/>
					<Toggle
						v-if="isEdit"
						class="mr-2"
						:value="resetIncrementalValue"
						label="Reset Incremental Value"
						tooltip-text="Choose an appropriate data field within the Cassie object to be used for incremental transfers. Each transfer will send any new information within Cassie, based on this field"
						:disabled="!userFullPermissions"
						@update:value="$emit('update:resetIncrementalValue', $event)"
					/>
				</div>
			</template>
		</SectionCard>
		<SectionCard>
			<template #title>
				Data Fields
			</template>
			<template #body>
				<div class="d-flex flex-row cassie-horizontal-sm">
					<Dropdown
						v-model="selectedFields"
						label="Fields"
						:items="cassieDataFields"
						multiple
						custom-sort
						persistent-hint
						:disabled="!userFullPermissions"
						class="cassie-input-width-md"
					/>
					<PrimaryActionButton
						v-if="userFullPermissions"
						@click="addFields"
					>
						Add
					</PrimaryActionButton>
				</div>
				<v-simple-table
					v-if="objectSelectList"
					dense
					light
				>
					<template #default>
						<thead>
							<tr>
								<th
									class="text-left"
									scope="col"
								>
									Field
								</th>
								<th
									v-if="userFullPermissions"
									class="text-right"
									scope="col"
								>
									Action
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(field, index) in objectSelectList"
								:key="index"
							>
								<td>
									{{ field }}
								</td>
								<td
									v-if="userFullPermissions"
									class="text-right"
								>
									<IconButton
										tooltip-text="Remove Data Field"
										@click="removeDataField(index)"
									>
										mdi-trash-can
									</IconButton>
								</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</template>
		</SectionCard>
		<SectionCard>
			<template #title>
				Data Filtering
			</template>
			<template #body>
				<TextArea
					:value="objectFilterClause"
					label="Data Filter Clause"
					:disabled="!userFullPermissions"
					tooltip-text="Enter an appropriate filter clause to be used to select data to transfer"
					@input="$emit('update:objectFilterClause', $event)"
				/>
			</template>
		</SectionCard>
		<SectionCard>
			<template #title>
				Enable Integration Service
			</template>
			<template #body>
				<Toggle
					class="mr-2"
					:value="isEnabled"
					label="Enable Integration Service"
					:disabled="!userFullPermissions"
					tooltip-text="Once enabled, any actions will commence. Only set to enabled and save changes when you are happy with all of the configured settings"
					@update:value="$emit('update:isEnabled', $event)"
				/>
			</template>
		</SectionCard>
	</validation-observer>
</template>
<script>
import { mapGetters } from 'vuex'
import SectionCard from '../../../../../../shared/components/section-card.vue'
import TextArea from '../../../../../../shared/components/textarea.vue'
import Dropdown from '../../../../../../shared/components/dropdown.vue'
import Toggle from '../../../../../../shared/components/toggle.vue'
import IconButton from '../../../../../../shared/components/icon-button.vue'
import PrimaryActionButton from '../../../../../../shared/components/primary-action-button.vue'

export default {
	components: { Dropdown, SectionCard, PrimaryActionButton, TextArea, IconButton, Toggle },
	props: {
		isEdit: Boolean,
		cassieObjectId: Number,
		objectIdColumn: String,
		resetIncrementalValue: Boolean,
		updateStandDak: Boolean,
		objectSelectList: [Array, String],
		objectFilterClause: String,
		isEnabled: Boolean,
		cassieObjects: Array,
		dataTypeItems: Array,
		targetSystemActionItems: Array,
		userFullPermissions: Boolean
	},
	data () {
		const CONTACTS_DATA_TYPE = 1
		const PREFERENCES_DATA_TYPE = 2
		return {
			selectedFields: [],
			CONTACTS_DATA_TYPE,
			PREFERENCES_DATA_TYPE
		}
	},
	computed: {
		...mapGetters('auth', ['productAreaPermission', 'userHasUniversalBrand']),

		incrementFieldItems () {
			return this.cassieObjects.find(({ cassieObjectId }) => cassieObjectId === this.cassieObjectId)?.cassieObjectIncrementalFields
		},
		cassieDataFields () {
			const foundCassieObjects = this.cassieObjects.find(({ cassieObjectId }) => cassieObjectId === this.cassieObjectId)?.cassieObjectFields
			let foundItems = foundCassieObjects?.map((value, index) => ({
				value: value,
				text: value
			}))

			foundItems = foundItems?.filter(({ value }) => !this.objectSelectList.includes(value))
			return foundItems
		}
	},
	methods: {
		updateObjectSelectList (objectSelectList) {
			this.$emit('update:objectSelectList', objectSelectList)
		},
		removeDataField (index) {
			const objectSelectList = [...this.objectSelectList]
			this.$delete(objectSelectList, index)
			this.updateObjectSelectList(objectSelectList)
		},
		addFields () {
			this.updateObjectSelectList([
				...this.objectSelectList,
				...this.selectedFields
			])
			this.selectedFields = []
		},
		displayResponseCode (index) {
			return this.successResponses[index]?.expectedSuccessResponseCode
		},
		displayResponseMessage (index) {
			return this.successResponses[index]?.expectedSuccessResponseMessage
		}
	}
}
</script>
